import script from "./CreatorChatVideoMemoRecorder.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorChatVideoMemoRecorder.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__